import { render } from "./BaseDialogFullscreenEditor.vue?vue&type=template&id=357e1660&scoped=true"
import script from "./BaseDialogFullscreenEditor.vue?vue&type=script&lang=js"
export * from "./BaseDialogFullscreenEditor.vue?vue&type=script&lang=js"

import "./BaseDialogFullscreenEditor.vue?vue&type=style&index=0&id=357e1660&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-357e1660"]])

export default __exports__